import { Backdrop, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";
import ClientConfig from "./components/clientConfig";
import AllowBuyers from "./components/allowBuyers";
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
const VendorClientBuyerConfig = () => {
  const [allClients, setAllClients] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [buyerList, setBuyerList] = useState([]);
  const {enqueueSnackbar}=useSnackbar()
  const [page, setPage] = useState(1);
  const [totalLength, setTotalLength] = useState(0);
  const entriesPerPage=50

  const GetClientList = async () => {
    setIsLoading(true);
    try {
      let clientlist = await TLinkApi.get("/clients/list");
      setAllClients(clientlist.data);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    GetClientList();
  }, []);

  const GetClientBuyerList = async () => {
    setIsLoading(true);
    try {
      let buyerList = await TLinkApi.get(
        `/clients/${selectedClient}/all-buyers?page=${1}&limit=${50000}`
      );
      if (buyerList?.data.data) {
        setBuyerList(
          buyerList?.data.data.map((val) => {
            return {
              id: String(val.buyerId),
              name: val.buyerName,  
            };
          })
        );
      } else {
        setBuyerList([]);
      }
      setTotalLength(buyerList?.data?.totalLength);
      setIsLoading(false);
    } catch (e) {
      console.log(e); 
      setBuyerList([]);
      enqueueSnackbar(e?.response?.data?.message, {
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedClient) {
      GetClientBuyerList();
    }
  }, [selectedClient]);



  return (
    <div style={{paddingTop:"0.5rem"}}>
      {isLoading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        ""
      )}
 
      <Grid container spacing={2}>
        <Grid item xs={3} >
          <ClientConfig
            allClients={allClients}
            setIsLoading={setIsLoading}
            setSelectedClient={setSelectedClient}
            selectedClient={selectedClient}
          />
        </Grid>
        <Grid item xs={3}>
          <AllowBuyers
            buyerList={buyerList}
            setIsLoading={setIsLoading}
            selectedClient={selectedClient}
            setSelectedClient={setSelectedClient}
            page={page}
            setPage={setPage}
            totalLength={totalLength}
            entriesPerPage={entriesPerPage}
            getBuyerList={GetClientBuyerList}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default VendorClientBuyerConfig;
